import { getPricingOfAccountEmailValidationCampaign } from "../types/account_campaign_pricing_email_validation_types";

const initState = {
  data: [],
  loading: false,
  error: null,
};

export default function accountCampaignPricingEmailValidationReducer(state = initState, action = {}) {
  switch (action.type) {
    case getPricingOfAccountEmailValidationCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getPricingOfAccountEmailValidationCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getPricingOfAccountEmailValidationCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
